import { makeStyles } from '@material-ui/core';
import { hSpacing } from 'src/common/helpers/config';
import { calculateWidth } from 'src/common/helpers/dimension-helper';

interface HomePageLayoutStyleProps {
  leftHanded?: boolean;
}

export const styles = makeStyles(() => ({
  middleArea: {
    width: '0',
  },
  itemListContainer: {
    width: calculateWidth(355).stringValue,
    marginRight: ({ leftHanded }: HomePageLayoutStyleProps) => (leftHanded ? 0 : hSpacing),
    marginLeft: ({ leftHanded }: HomePageLayoutStyleProps) => (!leftHanded ? 0 : hSpacing),
  },
  itemListContainerSmallForm: {
    width: calculateWidth(304, 1024).stringValue,
    marginRight: ({ leftHanded }: HomePageLayoutStyleProps) => (leftHanded ? 0 : hSpacing),
    marginLeft: ({ leftHanded }: HomePageLayoutStyleProps) => (!leftHanded ? 0 : hSpacing),
  },
}));
